import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { House, ShieldCheck, MagnifyingGlass, Table, GitDiff, FileText, Gear, SignOut, Scales, Triangle } from "@phosphor-icons/react";

const navItems = [
  { to: "/app", icon: House, label: "Dashboard", testid: "nav-dashboard", end: true },
  { to: "/app/marcas", icon: ShieldCheck, label: "Marcas monitoradas", testid: "nav-brands" },
  { to: "/app/varredura", icon: MagnifyingGlass, label: "Nova varredura", testid: "nav-scan" },
  { to: "/app/resultados", icon: Table, label: "Resultados", testid: "nav-results" },
  { to: "/app/comparador", icon: GitDiff, label: "Comparador de logos", testid: "nav-comparator" },
  { to: "/app/inpi", icon: Scales, label: "Monitoramento INPI", testid: "nav-inpi" },
  { to: "/app/relatorios", icon: FileText, label: "Relatórios", testid: "nav-reports" },
  { to: "/app/configuracoes", icon: Gear, label: "Configurações", testid: "nav-settings" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-[#F9FAFB]">
      {/* Sidebar */}
      <aside className="w-64 bg-[#0A3B2C] text-white flex flex-col shrink-0" data-testid="app-sidebar">
        <div className="px-6 py-6 border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 border-2 border-white flex items-center justify-center">
              <Triangle size={18} weight="bold" />
            </div>
            <div>
              <div className="font-heading font-bold text-lg leading-tight">Confidence</div>
              <div className="text-[10px] uppercase tracking-widest text-white/60">Brand Monitor</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-4 px-3 space-y-1">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors ${
                  isActive ? "bg-white text-[#0A3B2C] font-semibold" : "text-white/80 hover:bg-white/10"
                }`
              }
            >
              <it.icon size={18} weight="bold" />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <div className="text-xs text-white/60 mb-2">{user?.name}</div>
          <div className="text-[10px] uppercase text-white/40 mb-3">{user?.role}</div>
          <button
            data-testid="logout-btn"
            onClick={() => { logout(); navigate("/login"); }}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 border border-white/20 text-white text-xs hover:bg-white/10 transition-colors"
          >
            <SignOut size={14} /> Sair
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto">
        <div className="max-w-[1400px] px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
